// Listing helpers shared by the editor workspace, Discover and the dialogs.

import { formatPrice, getActiveSale, getSalePriceDisplay } from "../utils/saleUtils";

export const MAX_MOCKUPS = 10;

/** Whether the signed-in user may open a listing in the editor. */
export function listingAccessAllowed(detail, { isAdmin, userid }) {
  if (!detail) return false;
  if (isAdmin) return true;
  if (detail.is_bought || detail.is_free || detail.is_bundle_linked_and_bought) return true;
  const ownerId = detail.user?.id ?? detail.user_id ?? detail.user;
  return userid != null && ownerId != null && ownerId !== false && String(ownerId) === String(userid);
}

/** Card / thumbnail image, following the listing's own thumbnail choice. */
export function listingImage(listing) {
  if (!listing) return "";
  if (listing.use_main_file_as_thumbnail) return listing.compressed_file || listing.file || listing.thumbnails?.[0]?.image || "";
  return listing.thumbnails?.[0]?.image || listing.compressed_file || listing.file || "";
}

/** Large preview image for the product dialog. */
export function listingPreviewImage(listing) {
  return listing?.compressed_file || listing?.file || listingImage(listing);
}

/** Price with any active sale: { label, original, amount, free }. */
export function listingPrice(listing) {
  if (!listing || listing.is_free) return { label: "Free", original: null, amount: null, free: true };
  const sale = getSalePriceDisplay(listing.price, getActiveSale(listing));
  if (sale.displayDiscounted == null) return { label: "Free", original: null, amount: null, free: true };
  return {
    label: formatPrice(sale.displayDiscounted),
    original: sale.hasDiscount ? formatPrice(sale.displayOriginal) : null,
    amount: sale.displayDiscounted,
    free: false,
  };
}

/** Visible in the marketplace (Same creator lists every listing of a creator). */
export function isPublicListing(listing, userid) {
  if (!listing) return false;
  if (userid != null && String(listing.user_id) === String(userid)) return true;
  return listing.is_published !== false && !listing.is_blocked;
}

export const listingTitle = (listing) => listing?.title || listing?.product_name || `Mockup ${listing?.id ?? ""}`.trim();

/** Second card line: mockup type · creator. */
export function listingSubtitle(listing) {
  return [listing?.ai_models, listing?.user_name].filter(Boolean).join(" · ");
}
